<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    :id="objData.label"
    class="checkbox-tesaurus"
    :class="objData.subThemes ? 'thesaurus-clickable' : ''"
    @click="toggleFilter"
  >
    <div class="check-wrap">
      <div class="sau-input" :class="isMobile && tipus">
        <input
          v-model="internalCheck"
          type="checkbox"
          :name="objData.label"
          :indeterminate.prop="isIndeterminate"
          @click="(ev) => evStopPropagation(ev)"
        >
        <span>{{ objData.label.replace('~', ',') }}</span>
      </div>
      <div
        v-if="objData.subThemes"
        class="icon-chevron"
        :class="openOption ? 'open-header' : ''"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckboxSub',
  components: {},
  props: {
    objData: {
      type: Object,
    },
    internalChecks: {
      type: Array,
    },
    tipus: {
      type: String,
    },
    tree: {
      type: String,
      default: '',
    },
    openOption: {
      type: Boolean,
    }
  },
  data() {
    return {
      openFilter: false,
    }
  },
  computed: {
    internalCheck: {
      get() {
        return this.internalChecks.indexOf(this.tree + this.objData.label) !== -1 ? true : false
      },
      set() {
        this.$emit('change-internal-checks', this.tree + this.objData.label)
      },
    },
    isIndeterminate() {
      if (this.internalCheck) return false
      let finded = false
      //check subthemes
      const contains = (arr = [], m) => arr.some((txt) => txt.includes(m));
      if (this.objData.subThemes) {
        this.objData.subThemes.forEach(el => {
          
          if (!finded && contains(this.internalChecks, this.objData.label + ',' + el.label)) {
            finded = true
          }
          //check details
          else if (!finded && el.subThemes) {
            el.subThemes.forEach(det => {
              if (
                !finded &&
                this.internalChecks.indexOf(
                  this.objData.label + ',' + el.label + ',' + det.label
                ) !== -1
              ) {
                finded = true
              }
            })
          }
        })
      }
      if (finded) return true
      else return false
    },
  },
  watch: {},
  methods: {
    evStopPropagation(ev) {
      ev.stopPropagation()
    },
    toggleFilter(el) {
      if (this.objData.subThemes) {
        this.$emit('op-selected', el.currentTarget.id, this.tipus)
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.checkbox-tesaurus
  display: flex
  flex-direction: column
  margin-bottom: vw(6px)
  
  &.thesaurus-clickable
    cursor: pointer

  .check-wrap
    display: flex
    justify-content: space-between
    align-items: center
    padding: vw(3px) vw(10px)
    width: 100%

    &:hover
      border-radius: 4px
      background-color: $corporate_color_light

    .sau-input
      display: flex
      align-items: center
      gap: vw(5px)
      
      &.subtheme
        margin-left: vw(20px)
        
      &.detail
        margin-left: vw(40px)

    span
      m-font-size(14, 18)
      color: $grey-dark
      font-weight: 400
      
  .open-header
    .mobile &
      transform: rotate(180deg)
      animation-name: rotate

  .icon-chevron
    m-icon("chevron-down", 24)
    cursor: pointer
    transform: rotate(-90deg)
    transform-origin: 50% 55%
    animation: 0.3s
    
    .mobile &
      transform: rotate(0)
      
    &.open-header
      .mobile &
        transform: rotate(180deg)

  .subcheck-wrap
    margin-top: vw(6px)
    
@keyframes rotate
  from
    transform: rotate(0)

  to
    transform: rotate(180deg)
</style>